import { FC, ReactNode } from "react"
import styles from "./index.module.scss"



interface IProps {
    title: string
    icon: JSX.Element
    children: ReactNode
    className?: string
}


const SectionBehsaLanding: FC<IProps> = ({ title, icon, children, className }) => {
    return (
        <section className={styles.section + ` ${className ?? ""}`}>
            <div className={styles.header__section + " flex jcc gap-5"}>
                <i>{icon}</i>
                <h4>{title}</h4>
            </div>

            <div className={styles.ware_icon__section}>
                <svg width="283" height="48" viewBox="0 0 283 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M282 8.58218C246.667 4.58218 231.22 20.2622 196 14.276C162.5 8.58215 150 -8.91782 105 8.58218C60 26.0822 31.5 55.7759 0 45.2759" stroke="url(#paint0_linear_929_169)" />
                    <defs>
                        <linearGradient id="paint0_linear_929_169" x1="10" y1="47.7759" x2="282" y2="40.2759" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#D0D5DD" />
                            <stop offset="1" stopColor="#D0D5DD" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>

            <div className={styles.content__section + " mt-2xl"}>
                {children}
            </div>
        </section>
    )
}

export default SectionBehsaLanding